import { sanitizeHtml, type SanitizeHtmlOptions } from '@leaflink/stash-utils';
import type { ObjectDirective } from 'vue';

/**
 * Value for `v-sanitize-html`. Pass an HTML string, or an object to tighten the
 * allowlist for one use site (e.g. `{ html, options: { ALLOWED_TAGS: ['b'] } }`).
 */
export type SanitizeHtmlBinding =
  | string
  | null
  | undefined
  | { html: string | null | undefined; options?: SanitizeHtmlOptions };

function toSafeHtml(value: SanitizeHtmlBinding): string {
  if (value && typeof value === 'object') {
    return sanitizeHtml(value.html, value.options);
  }
  return sanitizeHtml(value);
}

/**
 * Render an HTML string as sanitized markup — a safe drop-in for `v-html`. Strips
 * script tags, event-handler attributes, and javascript: URLs before setting
 * `innerHTML`. Sanitizes in the browser only (mounted/updated), so it is SSR-safe.
 */
const sanitizeHtmlDirective: ObjectDirective<HTMLElement, SanitizeHtmlBinding> = {
  mounted(el, binding) {
    el.innerHTML = toSafeHtml(binding.value);
  },
  updated(el, binding) {
    el.innerHTML = toSafeHtml(binding.value);
  },
};

export default sanitizeHtmlDirective;
